<p-button
  [label]="buttonLabel"
  icon="fa-solid fa-clipboard-check"
  iconPos="right"
  [loading]="loading"
  [styleClass]="styleClass"
  (onClick)="validate()"
></p-button>
